<template>
  <div>
    <el-form ref="form" :model="multimediaForm" label-width="100px">
      <el-form-item label="课程名：">
        <el-input disabled v-model="multimediaForm.name"></el-input>
      </el-form-item>
      <el-form-item label="姓名：">
        <el-input disabled v-model="multimediaForm.childName"></el-input>
      </el-form-item>
      <el-form-item label="图片" v-if="defaultConfig.imageConfig && defaultConfig.imageConfig.enable">
        <p style="color:red">最多上传{{ defaultConfig.imageConfig.maxNumber }}张图片</p>
        <!-- <multi-upload :limit="defaultConfig.imageConfig.maxNumber" v-model="multimediaForm.image"></multi-upload> -->
        <uploadImage v-model="multimediaForm.image" :limit="defaultConfig.imageConfig.maxNumber"></uploadImage>
      </el-form-item>
      <el-form-item label="视频文件：" v-if="defaultConfig.imageConfig && defaultConfig.videoConfig.enable">
        <p style="color:red">最多上传{{ defaultConfig.videoConfig.maxNumber }}个视频</p>
        <upload-video v-model="multimediaForm.video" :limitNum="defaultConfig.videoConfig.maxNumber"
          ref="uploadRefs"></upload-video>
        <!-- v-model="multimediaForm.video" -->
      </el-form-item>
      <el-form-item label="备注：">
        <el-input  type="textarea" :autosize="{ minRows: 2, maxRows: 6 }"
          v-model="multimediaForm.remark"  maxlength="300" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="录音:" v-if="defaultConfig.audioEnable">
        <div style="width: 740px;display: flex;align-items: center;">
          <soundRecording ref="soundRecord" @clickRecStop="clickRecStop" @clickRecClear="clickRecClear" />
          <div v-if="audio" style="margin-left: 20px;">
            <audio controls ref="audio" class="aud" controlsList="nodownload noplaybackrate">
              <source :src="audio" />
            </audio>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import uploadVideo from "./upload-video.vue";
import soundRecording from "@/components/soundRecording";
import MultiUpload from "@/components/Upload/multiUpload";
import { getCourseMediaData } from "@/api/AfterClassService";
import uploadImage from '../../service/components/upload-image.vue'
import uploadVideo from '../../service/components/upload-video.vue'

export default {
  props: {
    courseRocordId: {
      type: [Number, String],
      default: null,
    },
    defaultConfig: {
      type: Object,
      default: () => { },
    },
    currentRow: {
      type: Object,
      default: () => { },
    }
  },
  components: {
    uploadVideo,
    uploadImage,
    soundRecording,
    MultiUpload
  },
  data() {
    return {
      multimediaForm: {
        image: [],
        video: [],
        audio: ''
      },
      audio: '',
      selectProductPics: [],
      limitNum: 2,
    };
  },
  methods: {
    clickRecStop(audio) {
      let self = this
      if (audio == 1) {
        this.$refs.soundRecord.recStop()
        let timer = setInterval(() => {
          self.audio = self.$refs.soundRecord.audio
          self.$refs.audio.src = self.audio
          self.multimediaForm.audio = self.audio
          self.$refs.soundRecord.dialogVisible = false
          clearInterval(timer)
        }, 500)
      } else {
        let timer = setInterval(() => {
          self.audio = self.$refs.soundRecord.audio
          self.$refs.audio.src = self.audio
          self.multimediaForm.audio = self.audio
          self.$refs.soundRecord.dialogVisible = false
          console.log(self.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      }
    },
    clickRecClear() {
      this.audio = ''
    },
    getFetch() {
      // console.log(this.courseRocordId,'this.courseRocordId====')
      // return
      getCourseMediaData({ id: this.courseRocordId }).then((response) => {
        console.log(response.data, "response多");
        this.multimediaForm = {
          ...response.data,
          image: response.data.image ? response.data.image : [],
          video: response.data.video ? response.data.video : [],
          ...this.currentRow
        }
   
        this.$nextTick(() => {
          if (response.data.audio) {
          this.$refs.soundRecord.recBlob = true
        }
          this.$refs.soundRecord.audio = response.data.audio
          this.$refs.soundRecord.localUrl = response.data.audio
          this.audio = response.data.audio
        console.log(this.audio , 'this.multimediaForm====')

          // this.$refs.audio.src = response.data.audio

        })
      });
    },
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/user-book-lesson/components/multimedia.vue